import { render, staticRenderFns } from "./FooterComponet.vue?vue&type=template&id=30e45550&"
import script from "./FooterComponet.vue?vue&type=script&lang=js&"
export * from "./FooterComponet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports